export const reportDayTypes = {
  GET_REPORT_DAYS: 'GET_REPORT_DAYS',
  SET_REPORT_DAY_FILTERS: 'SET_REPORT_DAY_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};